(ns superadmin.resource.name-search
  "Resource for name search functionality"
  (:require [common.url-template :as url-tpl]
            [re-frame.core :as rf]))

(rf/reg-event-fx :superadmin-resource.name-search/search
  [(rf/inject-cofx :sub :resource.user/token)
   (rf/inject-cofx :sub :url-context)]
  (fn [{:keys [db url-context :resource.user/token]} [_ name]]
    {:db (assoc db :superadmin-resource.name-search/results {:state :pending :value nil})
     :http
     {:method :get
      :uri (url-tpl/render :superadmin-api/name-search url-context {:name name})
      :headers {"Authorization" token}
      :on-success [:superadmin-resource.name-search/search-success]
      :on-failure [:superadmin-resource.name-search/search-failure]}}))

(rf/reg-event-db :superadmin-resource.name-search/search-success
  (fn [db [_ response]]
    (assoc db :superadmin-resource.name-search/results {:state :success :value (:results response)})))

(rf/reg-event-fx :superadmin-resource.name-search/search-failure
  (fn [{:keys [db]} _]
    {:db (assoc db :superadmin-resource.name-search/results {:state :failure :value nil})
     :dispatch [:toaster-bus/add {:id ::search-failure
                                  :type :error
                                  :message "Failed to search by name"}]}))

(rf/reg-sub :superadmin-resource.name-search/results
  (fn [db _]
    (:superadmin-resource.name-search/results db)))
